<template>
  <div id="administration">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          plain
          @click="searchBtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.frozen"
          icon="el-icon-key"
          plain
          @click="ThawingAndFreezing()"
          >冻结\解冻</el-button
        >
        <el-button
          v-if="jurisdiction.change"
          icon="el-icon-refresh"
          plain
          @click="replace()"
          >重新绑定会员</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          plain
          @click="openDeleteShow()"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="el-icon-edit-outline"
          plain
          @click="edit()"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.export"
          icon="iconfont icon-chakan1"
          plain
          @click="goToExamine()"
          >查看</el-button
        >
        <el-button
          v-if="jurisdiction.export"
          icon="el-icon-folder-opened"
          plain
          @click="exportShow = true"
          >导出</el-button
        >
      </div>
    </div>
    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          :label-position="labelPosition"
          label-width="150px"
          :model="searchForm"
          size="small"
          :inline="true"
        >
          <el-form-item label="申请人姓名\手机号">
            <el-input v-model="searchForm.search"></el-input>
          </el-form-item>
          <el-form-item label="公司">
            <el-input
              style="width: 100%"
              v-model="searchForm.company"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="searchForm.state">
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in optionsState"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期从">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 导出弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出会员GIADA Friends记录对话框"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>GIADA Friends记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="exporteBtn(templatei.gfcrmID)">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="unfreeze">
      <el-dialog
        :close-on-click-modal="false"
        width="470px"
        title="GIADA Friends申请-修改"
        :visible.sync="editShow"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="140px"
          style="margin-top: 10px"
          :inline="true"
        >
          <el-form-item label="GIADA Friends编号">
            <el-input v-model="editData.GFCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓">
            <el-input v-model="editData.GFLastName"></el-input>
          </el-form-item>
          <el-form-item label="名">
            <el-input v-model="editData.GFFirstName"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="editData.gender" placeholder="请选择">
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="CRM会员">
            <el-input v-model="templatei.custName" disabled></el-input>
          </el-form-item>
          <el-form-item label="移动电话">
            <el-input v-model="editData.mobile"></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input v-model="editData.company"></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input v-model="editData.position"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="editData.gfemail"></el-input>
          </el-form-item>
          <el-form-item label="省份">
            <el-select
              style="width: 100%"
              v-model="editData.stateID"
              @change="provinceChange"
              placeholder="请选择省份"
            >
              <el-option
                v-for="item in provinceData"
                :key="item.stateID"
                :value="item.stateID"
                :label="item.stateName_cn"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市">
            <el-select
              style="width: 100%"
              v-model="editData.cityID"
              placeholder="请选择城市"
            >
              <el-option
                v-for="item in cityData"
                :key="item.cityID"
                :value="item.cityID"
                :label="item.cityName_cn"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="editData.address"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitEdit()">保存</el-button>
          <el-button
            @click="
              (editShow = false),
                (editData = {}),
                (radioxz = ''),
                (templatei = {})
            "
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>

    <!-- 选择会员列表 -->
    <div class="unfreeze">
      <el-dialog
        :close-on-click-modal="false"
        width="70%"
        title="冻结卡级别—创建—选择会员"
        :visible.sync="memberListShow"
      >
        <SelectMember
          @close="closeMemberList"
          @submit="getChangeMemberInfo"
        ></SelectMember>
      </el-dialog>
    </div>

    <!-- 解冻\冻结弹窗 -->
    <div class="unfreeze">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="GIADA Friends管理-冻结\解冻"
        :visible.sync="unfreezeVisible"
      >
        <el-form size="mini" :inline="true" label-width="140px">
          <el-form-item label="GIADA Friends编号">
            <el-input v-model="templatei.gfcode" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              :value="templatei.gflastName + '' + templatei.gffirstName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="CRM会员">
            <el-input v-model="templatei.custName" disabled></el-input>
          </el-form-item>
          <el-form-item label="原状态">
            <el-input
              :value="
                templatei.state == 0
                  ? '有效'
                  : templatei.state == 1
                  ? '已冻结'
                  : '已无效'
              "
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="freezeBtn(templatei.gfcrmID)"
            v-if="templatei.state == 0"
            >冻结</el-button
          >
          <el-button @click="unfreezeBtn(templatei.gfcrmID)" v-else
            >解冻</el-button
          >
          <el-button @click="unfreezeVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 重新绑定会员弹窗 -->
    <div class="bound">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="GIADA Friends管理-重新绑定会员"
        :visible.sync="boundVisible"
      >
        <el-form size="mini" :inline="true" label-width="140px">
          <el-form-item label="GIADA Friends编号">
            <el-input v-model="templatei.gfcode" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              :value="templatei.gflastName + '' + templatei.gffirstName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="CRM会员">
            <el-input v-model="templatei.custName" disabled></el-input>
          </el-form-item>
          <el-form-item label="原状态">
            <el-input
              :value="
                templatei.state == 0
                  ? '有效'
                  : templatei.state == 1
                  ? '已冻结'
                  : '已无效'
              "
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="CRM会员">
            <div class="flex-between" @click="memberListShow = true">
              <el-input
                v-model="memberInfo.custName"
                style="width: 200px"
                readonly
              ></el-input>
              <el-button
                style="
                  border: 1px solid #6e6e6e;
                  background-color: #f5f5f5;
                  color: #4d4d4d;
                  margin-left: 5px;
                "
                size="mini"
                >选择会员</el-button
              >
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyMember()">保 存</el-button>
          <el-button @click="boundVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除会员GIADA Friends记录对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>GIADA Friends记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteBtn(templatei.gfcrmID)">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <!-- <Table :tableData="tableData" :configTable="configTable" @load="load"></Table> -->
      <el-card shadow="never" style="margin-top: 10px">
        <el-table
          height="530px"
          size="small"
          class="table-style"
          highlight-current-row
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="30">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radioxz"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column
            label="GIADA Frends编号"
            prop="gfcode"
            width="180"
          ></el-table-column>
          <el-table-column prop="firstName" label="姓名">
            <template slot-scope="scope"
              >{{ scope.row.gflastName }}{{ scope.row.gffirstName }}</template
            >
          </el-table-column>
          <el-table-column prop="custName" label="CRM会员"></el-table-column>
          <el-table-column prop="gender" label="性别"></el-table-column>
          <el-table-column
            prop="mobile"
            label="移动电话"
            width="100"
          ></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="position" label="职位"></el-table-column>
          <el-table-column prop="gfemail" label="邮箱"></el-table-column>
          <el-table-column prop="stateName" label="省份"></el-table-column>
          <el-table-column prop="cityName" label="城市"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              {{
                scope.row.state == 0
                  ? "有效"
                  : scope.row.state == 1
                  ? "已冻结"
                  : "已无效"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
          ></el-table-column>
          <el-table-column label="创建日期" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime !== null">
                {{ scope.row.createTime | dateFormat }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后修改人"
            width="100"
          ></el-table-column>
          <el-table-column label="最后修改日期" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            align="center"
            min-width="100"
            width="300"
          >
            <template slot-scope="scope">
              <div class="table-button">
                <el-button
                  size="mini"
                  icon="el-icon-key"
                  title="冻结\解冻"
                  @click="ThawingAndFreezing(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="重新绑定会员"
                  icon="el-icon-refresh"
                  @click="replace(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="删除"
                  icon="el-icon-delete"
                  @click="openDeleteShow(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="修改"
                  icon="el-icon-edit-outline"
                  @click="edit(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="查看"
                  icon="iconfont icon-chakan1"
                  @click="goToExamine(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </el-card>

      <el-alert
        v-if="total <= tableData.length"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      ></el-alert>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import {
  tubeQueryApi,
  bindApi,
  deleteApi,
  editApi,
  freezeApi,
  unfreezeApi,
  GfriendsexportApi,
} from "@/api/friends";
import { provinceApi, cityApi } from "@/api/region"; //省份、城市

import SelectMember from "@/components/selectMemberList";
export default {
  name: "centre",
  components: {
    SelectMember,
  },
  data() {
    return {
      exportShow: false,
      dateValue: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      memberListShow: false,
      provinceValue: "", // 选择的省份
      provinceData: [], //省份数据
      cityData: [], //城市数据
      editShow: false, //修改弹窗是否显示
      loading: false,
      // 选择会员radio
      radioxz: "",
      deleteFormVisible: false,
      // 冻结弹窗
      unfreezeVisible: false,
      // 重新绑定会员弹窗
      boundVisible: false,
      labelPosition: "right",
      labelPosition2: "top",
      searchForm: {
        pageNo: 1,
        pageSize: 20,
        search: "",
        company: "",
        state: "",
        startDay: "",
        endDay: "",
      },
      unfreezeForm: [],
      form: {
        name: "",
      },
      queryInfo: {
        cpyNO: getcpyNo(),
        pageNo: 1,
        pageSize: 20,
      },
      pageNum: 0,
      pageSize: 0,
      tableData: [],
      newTableDate: [], //滚动加载的数据
      optionsState: [
        {
          value: 0,
          label: "有效",
        },
        {
          value: 1,
          label: "已冻结",
        },
        {
          value: 2,
          label: "已无效",
        }
      ],
      templatei: {}, //选中数据
      editData: {
        GFCode: undefined,
        GFCrmID: undefined,
        GFEmail: undefined,
        GFFirstName: undefined,
        GFLastName: undefined,
        address: undefined,
        cityID: undefined,
        company: undefined,
        countryID: undefined,
        custID: undefined,
        gender: undefined,
        mobile: undefined,
        stateID: undefined,
        position: undefined,
      },
      memberInfo: {}, //重绑会员，选择的会员信息
      total: 0, //总数
      size: 0, //当前页条数
      bodyStyle: {
        padding: "0px",
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        frozen: false,
        delete: false,
        change: false,
        export: false,
        look: false,
      },
      url: "",
    };
  },
  created() {
    this.loading = true;
    this.tableList();
    let Administration = JSON.parse(localStorage.getItem("Administration"));
    for (let i = 0; i < Administration.length; i++) {
      if (Administration[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Administration[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Administration[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }

      if (Administration[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (Administration[i].menuName == "冻结\\解冻") {
        this.jurisdiction.frozen = true;
        continue;
      }
      if (Administration[i].menuName == "重新绑定会员") {
        this.jurisdiction.change = true;
        continue;
      }
      if (Administration[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
      if (Administration[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
  },
  computed: {
    onLoading() {
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    //确定导出
    exporteBtn() {
      if (this.dateValue && this.dateValue.length > 0) {
        this.searchForm.startDay = this.renderTime(this.dateValue[0]).substring(
          0,
          10
        );
        this.searchForm.endDay = this.renderTime(this.dateValue[1]).substring(
          0,
          10
        );
      } else {
        this.searchForm.startDay = "";
        this.searchForm.endDay = "";
      }
      let data = {
        endDay: this.searchForm.endDay,
        search: this.searchForm.search,
        startDay: this.searchForm.startDay,
        state: this.searchForm.state,
      };
      GfriendsexportApi(data).then((res) => {
        const ele = document.createElement("a");
        ele.style.display = "none";
        ele.href = process.env.VUE_APP_BASE_API + res.data;
        ele.download = "";
        document.querySelectorAll("body")[0].appendChild(ele);
        ele.click();
        ele.remove();
        this.exportShow = false;
      });
    },
    modifyMember() {
      bindApi({
        GFCrmID: this.templatei.gfcrmID,
        crmID: this.memberInfo.custID,
      }).then((res) => {
        if (res.message == "success") {
          this.$message.success(res.message);
          this.boundVisible = false;
          this.templatei = {};
          this.radioxz = "";
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
          this.memberInfo = {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //返回一条会员信息
    getChangeMemberInfo(data) {
      console.log(data);
      this.memberListShow = false;
      this.memberInfo = data;
    },
    closeMemberList() {
      console.log("触发2");
      this.memberListShow = false;
    },
    //打开修改弹窗
    edit(row) {
      if (this.provinceData.length < 1) {
        this.provinceList();
      }
      if (row) {
        this.templatei = row;
      }
      this.editData.GFCode = this.templatei.gfcode;
      this.editData.GFCrmID = this.templatei.gfcrmID;
      this.editData.GFEmail = this.templatei.gfemail;
      this.editData.GFFirstName = this.templatei.gffirstName;
      this.editData.GFLastName = this.templatei.gflastName;
      this.editData.address = this.templatei.address;
      this.editData.cityID = this.templatei.cityID;
      this.editData.company = this.templatei.company;
      this.editData.countryID = this.templatei.countryID;
      this.editData.custID = this.templatei.custID;
      this.editData.gender = this.templatei.gender;
      this.editData.mobile = this.templatei.mobile;
      this.editData.stateID = this.templatei.stateID;
      this.editData.position = this.templatei.position;
      console.log(this.templatei);
      if (this.templatei.gfcode || row) {
        this.provinceValue = this.templatei.stateID;
        if (this.templatei.stateID) {
          this.cityList();
        }
        this.editShow = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //打开删除弹窗
    openDeleteShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.gfcode || row) {
        this.deleteFormVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    // 更换绑定会员
    replace(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.gfcode || row) {
        this.boundVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    getCurrentRow(row) {
      // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
      this.templatei = row;
      console.log(this.templatei);
    },
    //冻结解冻弹窗
    ThawingAndFreezing(row) {
      if (row) {
        this.templatei = row;
      }

      console.log(this.templatei);
      if (this.templatei.gfcode || row) {
        this.unfreezeVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },

    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    goToExamine(row) {
      if (row) {
        this.templatei = row;
      }
      let that = this;
      console.log(this.templatei);
      if (this.templatei.gfcode || row) {
        this.$router.push({
          path: "/Examine",
          query: {
            custID: that.templatei.gfcrmID,
          },
        });
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //table表格数据
    async tableList() {
      this.loading = true;
      await tubeQueryApi(this.searchForm).then((res) => {
        this.tableData = this.tableData.concat(res.data.list);
        this.pageNum = res.data.pageNum;
        this.pageSize = res.data.size;
        this.total = res.data.total;
        this.size = res.data.size;
        this.loading = false;
      });
    },
    // 滚动列表加载数据
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.tableList();
        }
      }, 1000);
    },
    // 搜索
    searchBtn() {
      this.tableData = [];
      if (this.dateValue && this.dateValue.length > 0) {
        this.searchForm.startDay = this.renderTime(this.dateValue[0]).substring(
          0,
          10
        );
        this.searchForm.endDay = this.renderTime(this.dateValue[1]).substring(
          0,
          10
        );
      } else {
        this.searchForm.startDay = "";
        this.searchForm.endDay = "";
      }
      this.queryInfo.pageNo = 1;
      this.tableList();
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 冻结

    freezeBtn(GFCrmID) {
      freezeApi({
        GFCrmID: GFCrmID,
      }).then((res) => {
        if (res.message == "success") {
          this.$message.success(res.message);
          this.unfreezeVisible = false;
          this.templatei = {};
          this.radioxz = "";
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 解冻
    unfreezeBtn(GFCrmID) {
      unfreezeApi({
        GFCrmID: GFCrmID,
      }).then((res) => {
        if (res.message == "success") {
          this.$message.success(res.message);
          this.unfreezeVisible = false;
          this.templatei = {};
          this.radioxz = "";
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 重新绑定会员
    // 删除
    deleteBtn(GFCrmID) {
      deleteApi({
        GFCrmID: GFCrmID,
      }).then((res) => {
        if (res.message == "success") {
          console.log(res);
          this.$message.success(res.message);
          this.deleteFormVisible = false;
          this.templatei = {};
          this.radioxz = "";
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitEdit() {
      editApi(this.editData).then((res) => {
        if (res.message == "success") {
          console.log(res);
          this.$message.success(res.message);
          this.editShow = false;
          this.templatei = {};
          this.radioxz = "";
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //省份选择器选中触发
    provinceChange(value) {
      this.provinceValue = value;
      this.cityList();
      this.editData.cityID = "";
    },
    // 省份
    provinceList() {
      provinceApi({
        countryID: "CN",
      }).then((res) => {
        this.provinceData = res.data;
      });
    },
    // 城市
    cityList() {
      cityApi({ stateID: this.provinceValue }).then((res) => {
        this.cityData = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#administration {
  // height: 1400px;
  height: 100%;
}
.header {
  .header-text {
    width: 22rem;
    height: 50px;
    // margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .unfreeze {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }
    .el-form-item__content {
      line-height: 0px;
    }
  }
  .bound {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #6e6e6e !important;
    }
    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
